import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import './index.css'
import './i18n' // Import i18n config
import App from './App.jsx'
import { ThemeProvider } from './context/ThemeContext'

// Disable console logs in frontend
console.log = () => {};
console.debug = () => {};
console.info = () => {};

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <App />
      <Toaster
        position="bottom-left"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#fff',
            color: '#1f2937',
            border: '1px solid #e5e7eb',
            padding: '16px',
            borderRadius: '0',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '14px',
            letterSpacing: '0.025em',
          },
          success: {
            iconTheme: {
              primary: '#C5A686',
              secondary: '#fff',
            },
          },
        }}
      />
    </ThemeProvider>
  </StrictMode>,
)
